
export default {
  name: 'HomePage',
  components: {
    LandingPage: () => import('@/components/landing/LandingPage.vue'),
  },
}
